import { Badge } from "@devhop/ui";
import {
  Factory,
  Layers2,
  Monitor,
  ShoppingBag,
  type LucideIcon,
} from "lucide-react";
import {
  inferProductKind,
  PRODUCT_KIND_LABELS,
  type ProductKind,
} from "./product-kind";

const KIND_ICONS: Record<ProductKind, LucideIcon> = {
  retail: ShoppingBag,
  production: Factory,
  "online-showcase": Monitor,
  hybrid: Layers2,
};

const KIND_VARIANTS: Record<
  ProductKind,
  "default" | "secondary" | "outline"
> = {
  retail: "default",
  production: "secondary",
  "online-showcase": "secondary",
  hybrid: "outline",
};

type ProductKindBadgeProps = {
  kind?: ProductKind;
  isSellable?: boolean;
  isShowcaseEligible?: boolean;
};

export function ProductKindBadge({
  kind,
  isSellable = true,
  isShowcaseEligible = false,
}: ProductKindBadgeProps) {
  const resolved = inferProductKind(kind, isSellable, isShowcaseEligible);
  const { label } = PRODUCT_KIND_LABELS[resolved];
  const Icon = KIND_ICONS[resolved];

  return (
    <Badge variant={KIND_VARIANTS[resolved]} className="gap-1 font-normal">
      <Icon className="size-3 shrink-0" aria-hidden />
      {label}
    </Badge>
  );
}
